import { styled, Paper, Box } from "@mui/material";

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}))

export const BMWrapper = styled(Box)(() => ({
  height: "90vh",
  display: "flex",
  flexDirection: "column",
}))